<!-- 产品解决方案／群星金融N+1供应链金融产品 -->
<template>
  <div id="product">
    <header>
      <div class="container">
        <div class="header">
          <h2>平台产品</h2>
          <a href="#">了解群星的风控系统
            <div class="showCompare">
              <h1>与传统风控方式相比，群星金融依托平台大数据风控模型，能更精准、智能地核定企业额度及账期；实时获取供应链中的每一笔数据，确保每一笔采购的真实性；贷款后也可以在线了解企业经营情况，达到监控的目的。</h1>
              <h2>
                <span>群星大数据风控</span>
                VS
                <strong>传统风控方式</strong>
              </h2>
              <div class="contant">
                <span>-线上企业多维度信息的收集与整合，成本低、效率高</span>
                <strong>-传统线下繁复的企业调研，投入大、进展缓</strong>
              </div>
              <div class="contant">
                <span>-除企业必要静态资料外，核心企业实时上传与链属企业的贸易流水信息，融资及还款数据，平台可给予企业相应的信用评级等</span>
                <strong>-仅在企业申请融资时能获得企业的静态资料，如企业财务报表、贸易合同等，部分保理商需支付高昂的成本获取第三方的信用报告</strong>
              </div>
              <div class="contant">
                <span>-监控企业采购、应收账款生成、融资及回款资金的全过程</span>
                <strong>-不了解企业的真是经营情况，风险不透明、不可控</strong>
              </div>
              <div class="contant">
                <span>-大数据挖掘分析模型、快速分析企业信用，合理推荐企业额度账期</span>
                <strong>-资料信息多，导致授信审批决策难、决策慢</strong>
              </div>
              <div class="contant">
                <span style="border:none;border-right: 1px solid #d6d6d6;">-贷后管理难，定期确认企业的还款意愿（如电话沟通，邮寄材料）</span>
                <strong style="border:none;">-提供与企业实时沟通工具，贷款后也可以在线了解企业经营情况</strong>
              </div>
            </div>
          </a>
        </div>
        <h1>群星金融拥有专业的产品开发团队，可以提供给供应链各方线上平台服务。</h1>
        <h1>强大的数据风控能力并结合舒适的用户体验，</h1>
        <h1>让您轻松完成简单快捷的线上操作。</h1>
      </div>
    </header>
    <section>
      <h1>大企业适用的产品</h1>
      <h3>核心端操作平台、woodpecker等产品将结合资金方案等供应链金融服务为您盘活企业现金流。</h3>
      <div class="content">
        <h2>核心端操作平台</h2>
        <p>该平台实现供应链融资的全程电子化和全周期管理，核心企业可通过该平台使用群星提供的融资服务和引入的资金，同时通过平台优化信用管理体系及运营效率、提高资金使用率。</p>
        <div class='topage' @click="topage('platform', 'core')">进一步了解</div>
        <div class="slider-box">
          <div class="line">
            <div class="active" v-if="coreShow === 'platform'"></div>
            <div class="active" :style="coreShow === 'tool' ? 'top:47px;' : ''" v-else-if="coreShow === 'tool'"></div>
            <div class="active" :style="coreShow === 'product' ? 'top:94px;' : ''" v-else-if="coreShow === 'product'"></div>
          </div>
          <ul>
            <li @click="coreShow = 'platform'" :style="coreShow === 'platform' ? 'color:#000;' : ''">核心端操作平台</li>
            <li @click="coreShow = 'tool'" :style="coreShow === 'tool' ? 'color:#000;' : ''">智能诊断工具</li>
            <li @click="coreShow = 'product'" :style="coreShow === 'product' ? 'color:#000;' : ''">数据风控产品</li>
          </ul>
        </div>
        <div class="right-img">
          <img src="/imgs/portal/products/hx1@2x.png" alt="img" v-if="coreShow === 'platform'">
          <img src="/imgs/portal/products/hx2@2x.png" alt="img" v-else-if="coreShow === 'tool'">
          <img src="/imgs/portal/products/hx3@2x.png" alt="img" v-else-if="coreShow === 'product'">
        </div>
      </div>
    </section>
    <section>
      <h1>银行等金融机构适用的产品</h1>
      <h3>机构端操作平台、Shark等将结合数据分析供应链金融服务为您提供优质企业资源。</h3>
      <div class="content">
        <h2>数据风控产品</h2>
        <p>数据风控产品有Viper、Shark，Shark是具有群星特色的行为评分卡，该模型通过捕捉企业的动态行为，可以得到不同等级的信用分数，从而量化风险。供应商和经销商可以通过Shark查看自己的风险级别。</p>
        <div class='topage' @click="topage('platform', 'institution')">进一步了解</div>
        <div class="slider-box">
          <div class="line" style="height:95px">
            <div class="active" v-if="institutionShow === 'product'"></div>
            <div class="active" :style="institutionShow === 'platform' ? 'top:47px;' : ''" v-else-if="institutionShow === 'platform'"></div>
          </div>
          <ul>
            <li @click="institutionShow = 'product'" :style="institutionShow === 'product' ? 'color:#000;' : ''">数据风控产品</li>
            <li @click="institutionShow = 'platform'" :style="institutionShow === 'platform' ? 'color:#000;' : ''">机构端操作平台</li>
          </ul>
        </div>
        <div class="right-img">
          <img src="/imgs/portal/products/jg1@2x.png" alt="img" v-if="institutionShow === 'product'">
          <img src="/imgs/portal/products/jg2@2x.png" alt="img" v-else-if="institutionShow === 'platform'">
        </div>
      </div>
    </section>
    <section>
      <h1>供应商/经销商适用的产品</h1>
      <h3>核心端操作平台将结合链属营销等供应链金融服务为您解决资金难题。</h3>
      <div class="content">
        <h2 style="margin-top:85px;">链属端操作平台</h2>
        <p>链属端操作平台实现PC、APP、微信等多终端覆盖，同时优化用户体验，确保供应商和经销商随时随地完成货款结算，享受方便快捷的供应链金融服务。</p>
        <div class='topage' @click="topage('platform', 'chain')">进一步了解</div>
        <div class="right-img">
          <img src="/imgs/portal/products/ls1@2x.png" alt="img">
        </div>
      </div>
    </section>
    <div class="process">
      <h1>供应链各方线上平台流程一览</h1>
      <img src="/imgs/portal/products/step@2x.png" alt="img">
    </div>
    <portal-footer class="home-footer" :page='"download-home"'></portal-footer>
  </div>
</template>

<script>
import Footer from '../Footer'

export default {
  created () {
  },
  components: {
    'portal-footer': Footer
  },
  methods: {
    topage (way, query) {
      this.$router.push(
        {
          path: way,
          query: {
            role: query
          }
        }
      )
    }
  },
  data () {
    return {
      coreShow: 'platform',
      institutionShow: 'product'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/css/utils";
@import "../../css/theme-config";

#product {
  margin-top: 96px;
  background: #f2f2f2;
  font-family: PingFangSC-Regular;
  letter-spacing: 0.5px;
  overflow: hidden;
  h1 {
    font-family: PingFangSC-Medium;
  }
  a {
    font-size: 14px;
    color: #0070c9;
    letter-spacing: 0.29px;
    &::after {
      content: "";
      display: inline-block;
      position: relative;
      left: 5px;
    }
  }
  header {
    color: #ffffff;
    background: url("/imgs/portal/products/header-bg.png") center no-repeat;
    background-size: cover;
    .container {
      width: 1000px;
      margin: 0 auto;
      padding: 24px 0 40px 0;
      h1 {
        margin: 0;
        font-weight: normal;
        font-family: PingFangSC-Medium;
        font-size: 28px;
        color: #FFFFFF;
        letter-spacing: 1.75px;
        text-align: center;
        line-height: 42px;
      }
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        border-bottom: 1px solid rgba($color: #ffffff, $alpha: 0.2);
        margin-bottom: 40px;
        h2 {
          font-size: 24px;
          letter-spacing: 0.5px;
          margin: 2px 0;
          font-weight: 400;
        }
        a {
          color: #66bbff;
          font-size: 14px;
          letter-spacing: 0.5px;
          margin-right: 6px;
          &::after {
            width: 8px;
            height: 16px;
            background: url("/imgs/portal/home/enter@2x.png") 0 no-repeat;
            background-size: 100%;
            top: 3px;
          }
        }
        .showCompare{
          display: none;
          position: absolute;
          right: 0;
          top: 35px;
          z-index: 1;
          box-sizing: border-box;
          width: 528px;
          height: 542px;
          background: rgba($color: #ffffff, $alpha: 0.96);
          padding: 40px 49px;
          border-radius:4px;
          h1{
            font-family:PingFangSC-Regular;
            font-size:12px;
            color:#333333;
            letter-spacing:0.38px;
            text-align:justify;
            line-height:18px;
            margin-bottom: 30px;
          }
          h2{
            font-family:PingFangSC-Medium;
            font-size:14px;
            color:#333333;
            letter-spacing:0.44px;
            text-align:center;
            line-height:16px;
            margin-bottom: 13px;
            span{
              color: #ffffff;
              display: inline-block;
              background:#1f5dea;
              border-radius:4px;
              width:131px;
              height:30px;
              padding: 7px 0;
              box-sizing: border-box;
              margin-right: 32px;
            }
            strong{
              background:#a8acb9;
              padding: 7px 0;
              color: #ffffff;
              display: inline-block;
              border-radius:4px;
              width:131px;
              height:30px;
              box-sizing: border-box;
              margin-left: 32px;
            }
          }
          .contant{
            font-family:PingFangSC-Regular;
            font-size:12px;
            color:#333333;
            letter-spacing:0.38px;
            text-align:justify;
            line-height:18px;
            overflow: hidden;
            span{
              width: 190px;
              display: block;
              float: left;
              padding: 10px 15px 10px 0;
              border-bottom: 1px solid #d6d6d6;
              border-right: 1px solid #d6d6d6;
            }
            strong{
              width: 190px;
              display: block;
              float: left;
              padding: 10px 0 10px 15px;
              font-weight: normal;
              border-bottom: 1px solid #d6d6d6;
            }
          }
        }
        a:hover .showCompare{
          display: block;
        }
      }
    }
  }
  section {
    width: 1000px;
    margin: 0 auto;
    color: #333333;
    padding: 60px 0 177px 0;
    border: 1px solid #f2f2f2;
    h1 {
      font-size: 40px;
      color: #222222;
      letter-spacing: 1.25px;
      text-align: center;
      margin: 0;
      font-weight: normal;
    }
    h2 {
      font-size: 30px;
      font-family: PingFangSC-Semibold;
    }
    h3 {
      font-size: 21px;
      text-align: center;
      margin: 10px;
      font-weight: normal;
    }
    .content {
      padding-top: 90px;
      position: relative;
      h2 {
        margin: 18px 0;
        font-family: PingFangSC-Semibold;
        font-size: 30px;
        color: #333333;
        letter-spacing: 0.71px;
        line-height: 30px;
        font-weight: normal;
      }
      p {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0.5px;
        text-align: justify;
        line-height: 26px;
        width: 425px;
      }
      .topage {
        font-size: 24px;
        font-family: PingFangSC-Regular;
        font-size: 24px;
        color: #0070C9;
        letter-spacing: 0.5px;
        line-height: 24px;
        width: 140px;
        cursor: pointer;
        &::after {
          content: "";
          display: inline-block;
          position: relative;
          left: 5px;
          width: 10px;
          height: 16px;
          background: url("/imgs/portal/home/enter3@2x.png") 0 no-repeat;
          background-size: 100%;
          top: 0;
        }
      }
      .slider-box {
        margin-top: 91px;
        .line {
          width: 7px;
          height: 141px;
          background: #C6C6C6;
          float: left;
          position: relative;
          overflow: hidden;
          border-radius: 10px;
          div{
            position: absolute;
            left: 0;
            top: 0;
            width: 7px;
            height: 47px;
            border-radius: 10px;
          }
          .active{
            background: #000;
          }
        }
        ul{
          overflow: hidden;
          li{
            font-family: PingFangSC-Regular;
            font-size: 21px;
            color: #9B9B9B;
            letter-spacing: 0.5px;
            text-align: justify;
            line-height: 21px;
            padding: 10px 37px 15px;
            display: block;
            cursor: pointer;
          }
        }
      }
      .right-img {
        position: absolute;
        right: -290px;
        top: 90px;
        img{
          width: 880px;
        }
      }
    }
  }
  .process {
    width: 100%;
    height: 628px;
    background: url(/imgs/portal/products/platform_bg3@2x.png) center center no-repeat;
    background-size: cover;
    margin: 74px 0 0;
    overflow: hidden;
    h1{
      font-family: PingFangSC-Medium;
      font-size: 48px;
      color: #FFFFFF;
      letter-spacing: 1.5px;
      text-align: center;
      line-height: 48px;
      margin: 0;
      padding: 70px 0 52px;
    }
    img{
      width: 1000px;
      margin: 0 auto;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Product.vue?5ba80414